import { SpacingValues } from "@/lib/utils/SpacingValues";
import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { DateInput } from "@stenajs-webui/calendar";
import {
  Box,
  Column,
  Indent,
  Row,
  Space,
  Spacing,
  Text,
  Txt,
} from "@stenajs-webui/core";
import { FlatButton, PrimaryButton } from "@stenajs-webui/elements";
import { Window } from "@stenajs-webui/modal";
import { cssColor } from "@stenajs-webui/theme";
import * as React from "react";
import { ReactNode, useState } from "react";

interface Props {
  onSubmit: (breakDate: Date) => void;
  onRequestClose: () => void;
  errorBanner?: ReactNode;
  loading?: boolean;
}

export const CopyMultiLegRouteAgreementModal: React.FC<Props> = ({
  onSubmit,
  onRequestClose,
  errorBanner,
  loading,
}) => {
  const [breakDate, setBreakDate] = useState<Date | undefined>(new Date());

  const handleSubmit = () => {
    if (breakDate) {
      onSubmit(breakDate);
    }
  };

  return (
    <Window
      isOpen={true}
      width={"500px"}
      onRequestClose={onRequestClose}
      header={
        <Txt variant={"bold"} size={"large"}>
          Copy multi leg route agreement
        </Txt>
      }
    >
      <Column indent spacing>
        <Column indent spacing>
          <Text variant={"bold"}>
            Overlapping multi leg agreements are not allowed.
          </Text>
          <Spacing />
          <Text>
            You need to set a break date. The new agreement will be valid from
            the day after the selected break date.
          </Text>
          <Spacing num={SpacingValues.THIRTYTWO}>
            <Box width={"130px"}>
              <Text
                color={cssColor("--tjara")}
                size={"small"}
                whiteSpace={"nowrap"}
                variant={"bold"}
              >
                {"Set break date"}
              </Text>
              <Space />
              <DateInput
                value={breakDate}
                onChange={setBreakDate}
                portalTarget={document.body}
                zIndex={ZIndex.high}
                width="150px"
              />
            </Box>
          </Spacing>
          <Row justifyContent={"flex-end"}>
            <FlatButton onClick={onRequestClose} label={"Cancel"} />
            <Indent />
            <PrimaryButton
              onClick={handleSubmit}
              label={"Copy multi leg agreement"}
              loading={loading}
            />
          </Row>
        </Column>
        {errorBanner && (
          <>
            <Space num={4} />
            {errorBanner}
          </>
        )}
      </Column>
    </Window>
  );
};
